import styled from 'styled-components';
import { Box, Grid } from '@material-ui/core';
import { Typography } from 'components/core';

const CompanyName = styled(Typography)`
  display: block;
  max-width: 175px;
  min-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;
`;

const Container = styled(Box)`
  cursor: pointer;
  position: relative;
`;

const GridContainer = styled(Grid)`
  height: 55px;
`;

export const Styled = {
  CompanyName,
  Container,
  GridContainer,
};
